import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import IntlMessages from 'util/IntlMessages';
import classNames from 'classnames';

export default function TitleMenu({ collapsed, goBack, title, className }) {
  return (
    <div
      className={classNames(
        'gx-flex-row gx-justify-content-start gx-align-items-center gx-guarnic-gap-2 gx-mb-3',
        className,
      )}
    >
      {goBack && (
        <div>
          <Button
            className="gx-mb-0"
            shape="circle"
            icon={<LeftOutlined className="gx-text-black" />}
            size="middle"
            onClick={goBack}
          />
        </div>
      )}
      {!collapsed && (
        <div className="gx-mt-1">
          <span className="gx-fs-xl">
            {title ? title : <IntlMessages id="work.direction.title" />}
          </span>
        </div>
      )}
    </div>
  );
}
